.form {
    max-width: 600px;
    margin: 0 auto;
}